import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.admin', [
        // Modules d'administration
        'app.admin.metrics',
        'app.admin.monitoring',
        'app.admin.audit',
        'app.admin.periodictasks',
        'app.announcement',
        'app.global_setting'
    ]);
})();
